"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasheetEnsureSource = exports.DatasheetEnsureOutcome = exports.DatasheetEnsureRequestReason = void 0;
var DatasheetEnsureRequestReason;
(function (DatasheetEnsureRequestReason) {
    DatasheetEnsureRequestReason["PackageUsed"] = "package_used";
    DatasheetEnsureRequestReason["RetryDue"] = "retry_due";
    DatasheetEnsureRequestReason["OperatorRequest"] = "operator_request";
    DatasheetEnsureRequestReason["CliRequest"] = "cli_request";
    DatasheetEnsureRequestReason["CataloguePick"] = "catalogue_pick";
    DatasheetEnsureRequestReason["DatasheetRejected"] = "datasheet_rejected";
})(DatasheetEnsureRequestReason || (exports.DatasheetEnsureRequestReason = DatasheetEnsureRequestReason = {}));
var DatasheetEnsureOutcome;
(function (DatasheetEnsureOutcome) {
    DatasheetEnsureOutcome["Attached"] = "attached";
    DatasheetEnsureOutcome["AlreadyFound"] = "already_found";
    DatasheetEnsureOutcome["NotFound"] = "not_found";
    DatasheetEnsureOutcome["NotClaimed"] = "not_claimed";
    DatasheetEnsureOutcome["CandidateFound"] = "candidate_found";
    DatasheetEnsureOutcome["Failed"] = "failed";
})(DatasheetEnsureOutcome || (exports.DatasheetEnsureOutcome = DatasheetEnsureOutcome = {}));
var DatasheetEnsureSource;
(function (DatasheetEnsureSource) {
    DatasheetEnsureSource["Url"] = "url";
    DatasheetEnsureSource["LinkedUrl"] = "linked_url";
    DatasheetEnsureSource["Agent"] = "agent";
    DatasheetEnsureSource["SharedCatalogueDocument"] = "shared_catalogue_document";
    DatasheetEnsureSource["Series"] = "series";
    DatasheetEnsureSource["None"] = "none";
})(DatasheetEnsureSource || (exports.DatasheetEnsureSource = DatasheetEnsureSource = {}));
//# sourceMappingURL=datasheet-ensure.js.map